module.exports = __webpack_public_path__ + "img/logo.fd3554a4.png";